<!-- @format -->

<history-tag>

  <style>
    #footer{
      /*bottom:0;*/
    }
    h2:after {
      content: none;
    }
    h2{
      color: #25464C;
      font-size: 1.8rem;
    }

    .container_function{
      margin-top: 2rem;
    }
    .container_function .box_txt{
      width: 100%;
    }
    .wrap{
      font-size:1.25rem;
      line-height: 2.4;
    }
    p{
      margin: 0 0 5px 0;
      line-height: 2.0;
      font-size: 1em;
    }
    .wrap > p.description{
      margin: 0;
    }
    .history_item{
      border-bottom: 1px solid grey;
      padding-top: 1rem;
      padding-bottom: 1rem;
      list-style: none;
    }
    .history_item_block > dt{
      font-weight: bold;
    }
    a {
      color: #00894B;
    }
    a:hover {
      text-decoration: underline;
    }
    .history_list{
      margin-bottom: 1rem;
    }
    .history_type{
      display: inline-block;
      width: 120px;
      height: 18px;
      color: #FFFFFF;
      font-size: 0.7rem;
      text-align: center;
      line-height: 2.0rem;
      border-radius: 3px;
    }
    .history_type_notice{
      background-color: #6f94d9;
      color: #f6ffed;
    }
    .history_type_update{
      background-color: #2ca02c;
      color: #f6ffed;
    }
    .history_type_bugfix{
      background-color: #FFC24F;
      color: #7d2748;
    }
    .history_item_inner_ul{
      padding-left: 2rem;
    }

  </style>

  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item">
        <h1 class="heading-01 heading_manual">更新履歴</h1>
      </li>
    </ul>
  </div>
  <!--/.container_breadcrumb-->

  <div class="contents">
    <section class="contents_area">
      <div class="contents_block detail">
        <h3 class="heading-03 margin-spacing-2_bottom">更新履歴</h3>

        <div class="wrap">

          <p class="description">EDILENTの最近の更新履歴です。</p>
          <div class="container_function">
            <div class="box_txt">

              <ul class="history_list">

                <li class="history_item">
                  <dl class="history_item_block">
                    <dt>
                                    <span class="history_date">
                                        2022.03.18
                                    </span>

                    </dt>
                    <dd>
                      <dl>
                        <dt>
                          <span class="history_type history_type_notice">お知らせ</span>
                        </dt>
                        <dd>
                          <p>
                            2022年4月1日に利用規約の改定を予定しております。
                          </p>
                          <p>
                            詳細は<a href="/public/lp/release/20220318">こちら</a>からご確認ください。
                          </p>

                        </dd>
                      </dl>
                    </dd>
                  </dl>
                </li>
                <li class="history_item">
                  <dl class="history_item_block">
                    <dt>
                                    <span class="history_date">
                                        2021.12.16
                                    </span>

                    </dt>
                    <dd>
                      <dl>
                        <dt>
                          <span class="history_type history_type_update">機能追加・更新</span>
                        </dt>
                        <dd>
                          <p>
                            年末の会計処理にお役立ちいただけるよう、「支払調書」画面やマイナンバーの閲覧申請、郵送依頼への返信機能などを追加しました！
                          </p>
                          <p>
                            またサービス内で利用されている文言表記について、統一性を持たせるために一部修正を行いました。
                          </p>
                          <p>
                            <a href="/public/lp/release/20211216">支払調書関連の機能の追加の詳しいご説明についてはこちら</a>
                          </p>
                        </dd>
                      </dl>
                    </dd>
                  </dl>
                </li>
                <li class="history_item">
                  <dl class="history_item_block">
                    <dt>
                                    <span class="history_date">
                                        2021.10.04
                                    </span>

                    </dt>
                    <dd>
                      <dl>
                        <dt>
                          <span class="history_type history_type_update">機能追加・更新</span>
                        </dt>
                        <dd>
                          <p>
                            サービス内で使われている文言やテキストについて、修正を行いました
                          </p>
                        </dd>
                      </dl>
                    </dd>
                  </dl>
                </li>

                <li class="history_item">
                  <dl class="history_item_block">
                    <dt>
                                    <span class="history_date">
                                        2021.10.01
                                    </span>
                    </dt>
                    <dd>
                      <dl>
                        <dt>
                          <span class="history_type history_type_update">機能追加・更新</span>
                        </dt>
                        <dd>
                          <p>
                            画面に表示されるステータスラベルについて、文字が隠れてしまう場合があるので幅を調整しました
                          </p>
                        </dd>
                      </dl>
                    </dd>
                  </dl>
                </li>

                <li class="history_item">
                  <dl class="history_item_block">
                    <dt>
                                    <span class="history_date">
                                        2021.09.21
                                    </span>
                    </dt>
                    <dd>
                      <dl>
                        <dt>
                          <span class="history_type history_type_update">機能追加・更新</span>
                        </dt>
                        <dd>
                          <p>
                            サービス内の文言、テキストについて一部修正を行いました
                          </p>
                        </dd>
                      </dl>
                    </dd>
                  </dl>
                </li>
              </ul>


              <p>
                <a href="/">TOPページへ戻る</a>
              </p>
            </div><!--/.box_txt-->
          </div>


        </div>

      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
<script>
  import index from "@tags/pages/menu/help/index.riot";

  export default {
    state: {
      tag: "index"
    },
  }
</script>
</history-tag>
